import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { UserProfileComponent } from 'src/app/shared/components/user-profile/user-profile.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { UserType } from 'src/app/shared/constants/user-type.enum';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { StorageService } from '../../../providers/storage.service';

@Component({
  selector: 'sm-latest-users',
  templateUrl: './latest-users.component.html',
  styleUrls: ['./latest-users.component.scss']
})
export class LatestUsersComponent implements OnInit, OnDestroy {
  usersList: any[] = [];
  imageThumbUrl: string = environment.profileImageBaseUrl;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "name"
    },
    {
      columnName: "location",
      columnProperty: "state"
    },
    {
      columnName: "type",
      columnProperty: "userType"
    },
    {
      columnName: "phone",
      columnProperty: "phone"
    }
  ];
  private _apiSubscription: Subscription;

  constructor(private _storageService: StorageService,private _apiService: ApiService, private _dialog: MatDialog, private router: Router, private route: ActivatedRoute) {
    // this.usersList = USERS_LIST;
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_ALL_USERS_RESULT){
        console.log(resData);
        this.usersList = resData.result ? resData.result : [];
        this.usersList.forEach(user => {
          user.userType = UserType[user.userType]
        });
      }
    });
  }

  ngOnInit(): void {
  }

  viewProfile(profileData: any){
    this._dialog.open(UserProfileComponent, {
      data: profileData,
      maxWidth: 370,
      panelClass: 'user-profile-dialog'
    });
  }
  viewBusiness(value: any){
    console.log("click");
    this._storageService.setValueInAppStorage('specificEntityHash', value.hashId)
    this._storageService.setValueInAppStorage('specificEntityName', value.name)
    this.router.navigate(['users','entity-business'], {relativeTo: this.route})
    
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

}
